const state = {
  // Main App Sections
  modules: {
    budgets: {
      title: 'Budgets',
      icon: 'mdi-chart-bar',
      color: 'purple'
    },
    financialReports: {
      title: 'Financial Reports',
      icon: 'mdi-home-analytics',
      color: 'blue-grey'
    },
    financialSettings: {
      title: 'Financial Settings',
      icon: 'mdi-tune',
      color: 'blue'
    },
    journalEntry: {
      title: 'Journal Entry',
      icon: 'mdi-notebook',
      color: 'success'
    },
    chartOfAccounts: {
      title: 'Chart of Accounts',
      icon: 'mdi-chart-gantt',
      color: 'blue-grey'
    },
    balanceSheet: {
      title: 'Balance Sheet',
      icon: 'mdi-scale-balance',
      color: 'blue-grey'
    },
    accountTransactions: {
      title: 'Account Transactions',
      icon: 'mdi-format-list-bulleted',
      color: 'blue-grey'
    },
    accountTransactionsByReconciliation: {
      title: 'Account Transactions (By Reconciliation)',
      icon: 'mdi-format-list-bulleted',
      color: 'blue-grey'
    },
    profitAndLoss: {
      title: 'Profit and Loss',
      icon: 'mdi-chart-areaspline',
      color: 'blue-grey'
    },
    budgetCategories: {
      title: 'Budget Categories',
      icon: 'mdi-chart-bar-stacked',
      color: 'purple lighten-2'
    },
    budgetLines: {
      title: 'Budget Lines',
      icon: 'mdi-chart-sankey-variant',
      color: 'success lighten-2'
    },
    construction: {
      title: 'Construction Dashboard',
      icon: 'mdi-toolbox',
      color: 'warning'
    },
    software: {
      title: 'Software Dashboard',
      icon: 'mdi-code-tags',
      color: 'purple'
    },
    inquiries: {
      title: 'Inquiries Dashboard',
      icon: 'mdi-message-question',
      color: 'info'
    },
    accounting: {
      title: 'Accounting Dashboard',
      icon: 'mdi-bank',
      color: 'light-green'
    },
    assets: {
      title: 'Assets Dashboard',
      icon: 'mdi-ballot',
      color: 'orange darken-4'
    },
    estimates: {
      title: 'Estimates Dashboard',
      icon: 'mdi-file-document-multiple-outline',
      color: 'cyan'
    },
    estimateTemplates: {
      title: 'Templates',
      icon: 'mdi-file-hidden',
      color: 'cyan'
    },
    clients: {
      title: 'Clients',
      // icon: 'mdi-account-multiple',
      icon: 'mdi-contacts',
      color: 'purple lighten-2'
    },
    services: {
      title: 'Services',
      icon: 'mdi-store',
      color: 'primary'
    },
    fieldcrews: {
      title: 'Field Crews',
      icon: 'mdi-truck',
      color: 'orange'
    },
    inventory: {
      title: 'Inventory',
      icon: 'mdi-inbox-multiple',
      color: 'black'
    },
    product: {
      title: 'Product',
      icon: 'mdi-sprinkler',
      color: 'black'
    },
    labour: {
      title: 'Labour',
      icon: 'mdi-account-hard-hat',
      color: 'brown'
    },
    releases: {
      title: 'Releases',
      icon: 'mdi-tag-outline',
      color: 'teal'
    },
    vehicles: {
      title: 'Vehicles & Trailers',
      icon: 'mdi-truck',
      color: 'primary'
    },
    equipment: {
      title: 'Equipment',
      icon: 'mdi-hammer-screwdriver',
      color: 'primary'
    },
    projects: {
      title: 'Projects',
      icon: 'mdi-layers',
      color: 'deep-orange'
    },
    workorders: {
      title: 'Work Orders',
      icon: 'mdi-hammer-wrench',
      color: 'amber'
    },
    timesheets: {
      title: 'Timesheets',
      icon: 'mdi-clock-outline',
      color: 'purple'
    },
    payroll: {
      title: 'Payroll',
      icon: 'mdi-checkbook',
      color: 'indigo'
    },
    profile: {
      title: 'Profile',
      icon: 'mdi-account-box',
      color: 'indigo'
    },
    settings: {
      title: 'Settings',
      icon: 'mdi-tune',
      color: 'black'
    },
    staffing: {
      title: 'Staffing',
      icon: 'mdi-account-box-multiple',
      color: 'pink darken-4'
    },
    schedule: {
      title: 'Schedule',
      icon: 'mdi-calendar-text',
      color: 'teal'
    },
    scheduleTemplate: {
      title: 'Schedule Templates',
      icon: 'mdi-relative-scale',
      color: 'teal'
    },
    management: {
      title: 'Management',
      icon: 'mdi-lock',
      color: 'blue-grey darken-2'
    },
    notices: {
      title: 'Notices',
      icon: 'mdi-email',
      color: 'info'
    }
  },

  // Route specific (but not module specific)
  routes: {
    overview: {
      title: 'Overview',
      icon: 'mdi-binoculars',
      // icon: 'mdi-book-open-variant',
      // icon: 'mdi-select-group',
      iconColor: 'info'
    },
    // This is duplicated in the dataBox section
    actionTracker: {
      title: 'Action Tracker',
      icon: 'mdi-message-text',
      iconColor: 'cyan'
    }
  },

  // Data Box Header Info
  dataBox: {
    notes: {
      title: 'Notes',
      icon: 'mdi-note',
      iconColor: 'pink lighten-2'
    },
    stickies: {
      title: 'Stickies',
      icon: 'mdi-note',
      iconColor: 'yellow darken-2'
    },
    basics: {
      title: 'Basics',
      icon: 'mdi-information-outline',
      iconColor: 'primary'
    },
    company: {
      title: 'Company',
      icon: 'mdi-domain',
      iconColor: 'primary'
    },
    details: {
      title: 'Details',
      icon: 'mdi-format-list-bulleted',
      iconColor: 'cyan'
    },
    address: {
      title: 'Address',
      icon: 'mdi-map-marker',
      iconColor: 'orange'
    },
    invoices: {
      title: 'Invoices',
      // icon: 'mdi-cash-usd',
      icon: 'mdi-checkbook',
      color: 'success'
    },
    invoiceHolds: {
      title: 'Holds',
      icon: 'mdi-hand-right',
      color: 'error'
    },
    // This is duplicated in the routes section
    actionTracker: {
      title: 'Action Tracker',
      icon: 'mdi-message-text',
      iconColor: 'cyan'
    },
    payments: {
      title: 'Payments',
      icon: 'mdi-credit-card-outline',
      iconColor: 'grey'
    },
    expenses: {
      title: 'Expenses',
      icon: 'mdi-finance',
      iconColor: 'error'
    },
    overdueActions: {
      title: 'Overdue Actions',
      icon: 'mdi-alarm',
      iconColor: 'red'
    },
    crewVisits: {
      title: 'Crew Visits',
      icon: 'mdi-car-pickup',
      iconColor: 'blue-grey'
    },
    divisions: {
      title: 'Divisions',
      icon: 'mdi-division-box',
      iconColor: 'primary'
    },
    bankRecs: {
      title: 'Reconciliations',
      icon: 'mdi-file-compare',
      iconColor: 'dark-green'
    },
    deposits: {
      title: 'Deposits',
      icon: 'mdi-inbox-arrow-down',
      iconColor: 'light-green'
    },
    creditCards: {
      title: 'Credit Cards',
      icon: 'mdi-credit-card-outline',
      iconColor: 'teal'
    },
    accounts: {
      title: 'Accounts',
      icon: 'mdi-chart-tree',
      iconColor: 'blue darken-3'
    },
    report: {
      title: 'Reports',
      icon: 'mdi-file-chart',
      iconColor: 'blue darken-4'
    },
    subdTier: {
      title: 'SUBD Tier',
      icon: 'mdi-layers-outline',
      iconColor: 'info'
    },
    mechanical: {
      title: 'Mechanical',
      icon: 'mdi-pipe',
      iconColor: 'brown darken-2'
    }
  },
  archive: {
    title: 'Archived',
    icon: 'mdi-archive',
    iconColor: 'error'
  },
  highSeasonHelp: {
    title: 'High season help',
    icon: 'mdi-account-hard-hat',
    iconColor: 'blue-grey'
  },
  snowTracker: {
    title: 'Snow Tracker',
    icon: 'mdi-weather-windy-variant',
    iconColor: 'light-blue'
  }
}

const getters = {
  getIcons: state => state
}

export default {
  state,
  getters
}
